/**
 * Shown in place of a Pro-gated feature for free users. Links to Billing.
 */
import { Link } from 'react-router-dom';
import { Card, CardContent } from '../ui/card';
import { Button } from '../ui/button';

interface ProUpgradeCardProps {
  /** Short name of the gated feature, e.g. "Cost analytics". */
  feature?: string;
  /** Optional one-line description of what unlocks. */
  description?: string;
}

export function ProUpgradeCard({ feature, description }: ProUpgradeCardProps) {
  return (
    <Card className="max-w-lg mx-auto my-12 border-primary/30">
      <CardContent className="pt-6 text-center space-y-3">
        <div className="text-4xl">⭐</div>
        <h2 className="text-xl font-semibold">
          {feature ?? 'This feature'} is a Pro feature
        </h2>
        <p className="text-muted-foreground">
          {description ??
            'Upgrade to Pro ($29/mo) to unlock advanced analytics, all orchestration modes, and template publishing.'}
        </p>
        <Button asChild>
          <Link to="/billing">Upgrade to Pro</Link>
        </Button>
      </CardContent>
    </Card>
  );
}
